import {UserHistoryView} from "../user-history/views/user-history";
import {UserHistoryModel} from "../user-history/models/user-history";
import {autoinject} from "aurelia-dependency-injection";
import {AppEvents} from "../app-events";
import {MasterView} from "../shared/views/master-view";
import {TemplateManager} from "../shared/helpers/template-manager";
import "../user-history/styles/user-history.less";
import { AuthService } from "../authentication/auth-service";

@autoinject
export class UserHistoryModule extends Backbone.Model {

    private userHistoryRegion: Marionette.Region;

    constructor(
        private appEvents: Backbone.Events,
        private userHistoryView: UserHistoryView,
        private userHistoryModel: UserHistoryModel,
        private masterView: MasterView,
        private templateManager: TemplateManager,
        private authService: AuthService) {
        super();
        this.setupViews();
    }

    public show(): void {
        $("#viewport-content").addClass("user-history");
        this.templateManager.getTemplate("userhistory").then((template) => {
            this.userHistoryModel.resetDataWithCurrentTimeSpan();
            this.userHistoryView = new UserHistoryView(this.authService.AppUser, this.userHistoryModel);
            this.userHistoryView.template = template.Raw;
            this.userHistoryRegion.show(this.userHistoryView);
        });
    }

    public hide(): void {
        $("#viewport-content").removeClass("user-history");
    }

    public reset(): void {
        this.userHistoryModel.Items.reset([]);
        this.userHistoryModel.setDefaults();
        this.userHistoryModel.recalculateUrl();
        this.userHistoryRegion.empty({preventDestroy: true});
    }

    private setupViews(): void {
        this.listenToOnce(this.masterView, "render", () => {
            this.userHistoryRegion = this.masterView.addRegion("userHistoryRegion", "#user-history-region");
        });
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/user-history/user-history-module.ts